module.exports = __webpack_public_path__ + "static/media/birds-eye-village-annotated-mobile-cropped.ba857cd5.png";